import { useEffect } from 'react';
import SidebarDashboard from './sidebarDashboard';
import NavbarDashboard from './navbarDashboard';
import FooterDashboard from './footerDashboard';

export default function DashboardLayout({ children }) {
  useEffect(() => {
    // Ensure dashboard body classes are set
    if (!document.body.classList.contains('main-wrapper')) {
      // The main-wrapper class should be on a div, not body
      // But ensure body has proper classes for dashboard
    }

    // Initialize feather icons after component mounts
    const initFeather = () => {
      if (window.feather) {
        window.feather.replace();
      } else {
        // Wait for feather to load if not available yet
        setTimeout(initFeather, 100);
      }
    };

    // Initialize Bootstrap dropdowns
    const initBootstrapDropdowns = () => {
      // Check if Bootstrap is available
      if (window.bootstrap && window.bootstrap.Dropdown) {
        // Initialize all dropdowns
        const dropdownElementList = document.querySelectorAll('.dropdown-toggle');
        dropdownElementList.forEach((dropdownToggleEl) => {
          // Check if dropdown is already initialized
          const existingDropdown = window.bootstrap.Dropdown.getInstance(dropdownToggleEl);
          if (!existingDropdown) {
            try {
              new window.bootstrap.Dropdown(dropdownToggleEl);
            } catch (e) {
              console.log('Error initializing dropdown:', e);
            }
          }
        });
      } else {
        // Retry if Bootstrap is not loaded yet
        setTimeout(initBootstrapDropdowns, 100);
      }
    };

    // Initialize sidebar toggler
    const initSidebarToggler = () => {
      const sidebarToggler = document.querySelector('.sidebar-toggler');
      if (sidebarToggler) {
        // Use event delegation or check if listener already exists
        sidebarToggler.addEventListener('click', function handleToggle(e) {
          e.preventDefault();
          document.body.classList.toggle('sidebar-toggle');
        }, { once: false });
      }
    };

    // Initialize after a short delay to ensure scripts are loaded
    const timer = setTimeout(() => {
      initFeather();
      initBootstrapDropdowns();
      initSidebarToggler();
    }, 500);

    // Also re-initialize when children change (route changes within dashboard)
    const reinitTimer = setTimeout(() => {
      initFeather();
      initBootstrapDropdowns();
    }, 1000);

    return () => {
      clearTimeout(timer);
      clearTimeout(reinitTimer);
    };
  }, [children]);

  return (
    <div className="main-wrapper">
      <SidebarDashboard />
      <div className="page-wrapper">
        <NavbarDashboard />
        <div className="page-content">{children}</div>
        <FooterDashboard />
      </div>
    </div>
  );
}
